import React, { useEffect, useState } from 'react';
import classes from './speaker-test.module.scss';
import { ReactComponent as SpeakerTwoWavesIcon } from '../../../img/speaker-two-waves.svg'
import { ReactComponent as SpeakerOneWaveIcon } from '../../../img/speaker-one-wave.svg';
import { ReactComponent as SpeakerNoWavesIcon } from '../../../img/speaker-no-waves.svg';
import { AudioElement } from '../../../types/types';
import cn from 'classnames';
import testSound from '../../../audio/sound-test.mp3';

interface SpeakerTestProps {
  sinkId?: string;
}

const SpeakerTest = ({ sinkId }: SpeakerTestProps) => {
  const [audio] = useState<AudioElement>(new Audio(testSound) as AudioElement);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    if (started) {
      audio.pause();
      audio.currentTime = 0;
      setStarted(false);
    }
    // eslint-disable-next-line
  }, [sinkId]);

  useEffect(() => {
    audio.addEventListener('pause', handleEnded);
    audio.addEventListener('ended', handleEnded);

    return () => {
      audio.removeEventListener('pause', handleEnded);
      audio.removeEventListener('ended', handleEnded);
    };
  }, [audio, setStarted]);

  const togglePlay = async () => {
    if (started) {
      audio.pause();
      audio.currentTime = 0;
    } else {
      if (sinkId && typeof audio.setSinkId === 'function') {
        try {
          await audio.setSinkId(sinkId);
        } catch (error) {
          console.error('Error setting sink ID:', error);
        }
      }
      audio.play();
    }
    setStarted(!started);
  };

  const handleEnded = () => {
    setStarted(false);
  };

  return (
    <div
      className={cn(classes.speakerTest, {
        [classes.speakerTest_started]: started,
      })}
      onClick={() => togglePlay()}
    >
      <div className={classes.speakerTest__iconWrapper}>
        <SpeakerTwoWavesIcon
          className={cn(classes.speakerTest__icon, classes.speakerTest__icon_twoWaves)}
        />
        <SpeakerOneWaveIcon
          className={cn(classes.speakerTest__icon, classes.speakerTest__icon_oneWave)}
        />
        <SpeakerNoWavesIcon
          className={cn(classes.speakerTest__icon, classes.speakerTest__icon_noWaves)}
        />
      </div>
      <div className={classes.speakerTest__text}>Проверить динамики</div>
    </div>
  );
}

export default SpeakerTest;
